<template>
  <div class="gmf-compact-profile-card-wrap" v-if="profile">
    <!-- @TODO use avatar component -->
    <div class="gmf-compact-profile-card-avatar">
      <Avatar :customer="profile" disablePopup :customizable="customizable" :animated="animatedAvatar" />
    </div>
    <div class="gmf-compact-profile-card-nameandstats">
      <div class="gmf-subheader" v-text="customerName"></div>
      <CustomerLevelRow :customer="profile" />
      <div class="gmf-compact-profile-card-stats" v-if="! hideStats">
        <div class="gmf-align-icon-text-center">
          <span><Icon class="gmf-profile-stat-icon" icon="stats_achievements" /></span>
          <span class="gmf-profile-stat-number">{{ profile.unlockedAchievementCount }}</span>
        </div>
        <div class="gmf-align-icon-text-center">
          <span><Icon class="gmf-profile-stat-icon" icon="stats_comments" /></span>
          <span class="gmf-profile-stat-number">{{ profile.commentCount }}</span>
        </div>
        <div class="gmf-align-icon-text-center">
          <span><Icon class="gmf-profile-stat-icon" icon="stats_likes" /></span>
          <span class="gmf-profile-stat-number">{{ profile.receivedUpvoteCount }}</span>
        </div>

        <LootCrateButton v-if="showLootCrates"></LootCrateButton>
        <TutorialButton width="20px" height="20px"></TutorialButton>
      </div>
    </div>
    <CustomerAttributePills v-if="attributes" :attributes="attributes" location="compactProfileCard" :maxLines="2" />
  </div>
</template>

<style>
.gmf-compact-profile-card {
  /*width: 400px;*/
  max-width: 100%;
}
.gmf-compact-profile-card-wrap {
  display: flex;
  gap: var(--gmf-p-3);
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}
.gmf-compact-profile-card-wrap .gmf-customer-attributes {
  flex-basis: 100%;
}
.gmf-compact-profile-card-avatar .gmf-avatar {
  width: 80px;
  height: 80px;
}
.gmf-compact-profile-card-nameandstats .gmf-subheader {
  margin-bottom: var(--gmf-p-1);
}
.gmf-compact-profile-card-stats {
  display: flex;
  align-items: center;
  gap: var(--gmf-p-4);
  margin-top: var(--gmf-p-3);
}
.gmf-compact-profile-card-stats .gmf-profile-stat-number {
  font-weight: bold;
  font-size: var(--gmf-subheader-font-size);
}
.gmf-align-icon-text-center {
  display: flex;
  align-items: center;
}
</style>

<script>
import squircle from '@/utils/directives/squircle';
import state from '@/state';
import Avatar from '@/components/Avatar';
import CustomerLevelRow from '@/components/CustomerLevelRow';
import CustomerAttributePills from '@/components/CustomerAttributePills';
import LootCrateButton from '@/components/LootCrates/LootCrateButton.vue';
import Icon from '@/components/Icon';
import TutorialButton from '@/components/TutorialButton.vue';

export default {
  directives: {
    squircle
  },
  name: 'CompactProfileCard',
  components: {
    Avatar,
    CustomerLevelRow,
    CustomerAttributePills,
    LootCrateButton,
    Icon,
    TutorialButton,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    customizable: {
      type: Boolean,
      default: false,
    },
    hideAttributes: {
      type: Boolean,
      default: false,
    },
    hideStats: {
      type: Boolean,
      default: false,
    },
    showLootCrates: {
      type: Boolean,
      default: false,
    },
    animatedAvatar: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    t: state.t,
  },
  computed: {
    attributes () {
      if (this.hideAttributes) {
        return null;
      }
      return this.profile.attributesJson ? JSON.parse(this.profile.attributesJson) : null;
    },
    customerName () {
      if (this.profile.name) {
        return this.profile.name;
      }
      return state.t('comments.anonymous');
    },
  },
};
</script>
